import {
  PostingCategoryKind,
  PostingRangeKind,
  PostingTextKind,
} from '@revelio/data-access';

export type PostingDiscoveryTag =
  | PostingCategoryKind
  | PostingRangeKind
  | PostingTextKind;

export const PostingDiscoveryTags = {
  City: PostingCategoryKind.City,
  CompanyId: PostingCategoryKind.CompanyId,
  Country: PostingCategoryKind.Country,
  Msa: PostingCategoryKind.Msa,
  Rcid: PostingCategoryKind.Rcid,
  Region: PostingCategoryKind.Region,
  RemoteType: PostingCategoryKind.RemoteType,
  RicsK10: PostingCategoryKind.RicsK10,
  RicsK50: PostingCategoryKind.RicsK50,
  RicsK400: PostingCategoryKind.RicsK400,
  Seniority: PostingCategoryKind.Seniority,
  State: PostingCategoryKind.State,
  // Range
  PostDate: PostingRangeKind.PostDate,
  Salary: PostingRangeKind.Salary,
  // Text
  Description: PostingTextKind.Description,
  Jobtitle: PostingTextKind.Jobtitle,
} as const;
